<mat-tab-group
  *ngIf="candidate; else loading"
  class="tabs clear-background"
>
  <mat-tab
    label="EXPERIENCE"
    *ngIf="candidate?.experiences?.length > 0"
  >
    <ng-template matTabContent>
      <mojo-candidate-resume-experience
        [overview]="candidate?.overview"
        [keywords]="keywords"
        [experiences]="candidate?.experiences"
      >
      </mojo-candidate-resume-experience>
    </ng-template>
  </mat-tab>

  <mat-tab
    label="SKILLS"
    *ngIf="hardSkills?.length > 0 || softSkills?.length > 0"
  >
    <ng-template matTabContent>
      <mojo-candidate-resume-skills
        [keywords]="keywords"
        [hardSkills]="hardSkills"
        [softSkills]="softSkills"
      >
      </mojo-candidate-resume-skills>
    </ng-template>
  </mat-tab>

  <mat-tab
    label="EDUCATION"
    *ngIf="candidate?.educations?.length > 0"
  >
    <ng-template matTabContent>
      <mojo-candidate-resume-education
        [keywords]="keywords"
        [educations]="candidate?.educations"
      >
      </mojo-candidate-resume-education>
    </ng-template>
  </mat-tab>

  <mat-tab
    label="CERTIFICATION"
    *ngIf="candidate?.application?.certifications?.length > 0"
  >
    <ng-template matTabContent>
      <mojo-candidate-resume-certifications
        [keywords]="keywords"
        [certifications]="candidate?.application?.certifications"
      >
      </mojo-candidate-resume-certifications>
    </ng-template>
  </mat-tab>

  <mat-tab
    label="ACHIEVEMENTS"
    *ngIf="candidate?.application?.achievements?.length > 0"
  >
    <ng-template matTabContent>
      <mojo-candidate-resume-achievements
        [keywords]="keywords"
        [achievements]="candidate?.application?.achievements"
      >
      </mojo-candidate-resume-achievements>
    </ng-template>
  </mat-tab>
</mat-tab-group>
<ng-template #loading>
  <mojo-loader></mojo-loader>
</ng-template>
